import Header from "./Header";
import Footer from "./Footer";

function Faq() {
  return (
    <>
      <Header />

      <section class="position-relative z-1 mt-1 bg-dark-1">
        <div class="container">
          <div class="row align-items-center g-0 rounded-5 overflow-hidden">
            <div class="col-lg-7 col-12">
              <div className="my-5 py-5">
                <h2 class="text-white fw-medium ls-sm mt-0 mb-3">
                  <span class="">Face-Powered</span> Gallery
                </h2>
                <p class="lead text-white opacity-75 mb-5 fw-normal lh-sm">
                  Visualaey is an AI-powered, cloud-native platform that
                  automatically finds and delivers every photo you're in—just by
                  uploading a selfie.
                </p>
                <div class="">
                  <a class="btn btn-light px-5 btn-md rounded-pill">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pb-7 pt-5 bg-white">
        <div class="container mb-2">
          <div class="row">
            <div class="col-12">
              <div class="row text-center d-flex justify-content-center">
                <div class="col-lg-7 col-md-12 px-lg-8 mb-3">
                  <h1 class="fw-bold mb-0">
                    Do you want more{" "}
                    <u>
                      <span>information?</span>
                    </u>
                  </h1>
                  <p class="lead opacity-75 lh-sm mt-2">
                    Dive into our FAQs to find detailed insights, helpful tips,
                    and everything you need to know about Visualaey
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-10 pb-lg-0 pb-3 d-flex align-items-center">
              <div
                class="accordion accordion-flush w-100 pe-lg-5 pe-0 me-lg-5 me-0"
                id="accordionFlushExample"
              >
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        How does Visualaey work?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 opacity-75 lh-sm">
                        Visualaey uses facial recognition and deep learning
                        to identify individuals in event photos. Guests simply
                        upload a selfie, and our AI instantly finds and collects
                        every image they appear in—no manual tagging required.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        Is the platform secure and private?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    class="accordion-collapse collapse show"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 opacity-75 lh-sm">
                        Yes. We use industry-standard security protocols (OAuth
                        2.0 / JWT) and end-to-end encryption to protect your
                        data. Facial data is processed securely and never shared
                        or sold.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        What types of events is Visualaey best for?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 opacity-75 lh-sm">
                        Visualaey is perfect for weddings, parties,
                        birthdays, reunions, corporate events, festivals, and
                        more—anywhere multiple photos and people are involved.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item mt-1">
                  <h2 class="accordion-header">
                    <button
                      class="accordion-button px-0 bg-light px-5 rounded-pill collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      <h3 class="fs-4 text-dark fw-medium m-0">
                        How many events can I create for free?
                      </h3>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    class="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body px-5">
                      <p class="fs-4 fw-light mb-4 opacity-75 lh-sm">
                        Your first 3 events are completely free—with full access
                        to all features. After that, you can upgrade to a
                        simple, flexible subscription plan.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-6 text-center">
              <a href="#" class="lead lh-1">
                More questions? Visit the Help Center{" "}
                <i className="bi bi-arrow-right fs-4 ms-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Faq;
